/**
 * Contact form behaviour (plan 20260820-170108 follow-up, 2026-08-25).
 *
 * Two jobs, both progressive enhancement — with JS off the form still submits
 * every field, it just shows the returns block all the time instead of on demand.
 *
 *  1. Reveal the returns-specific fields only when the shopper picks
 *     "Return request". Every field visible up front costs completions, and
 *     someone asking a simple question should not scroll past return reasons.
 *
 *  2. Preselect the reason from the URL, so a "Start a return" button anywhere
 *     on the site can land the shopper on the form with the right context
 *     already chosen: /pages/contact?reason=return
 *
 * The order number is still typed by hand. It cannot be otherwise for a shopper
 * who is not logged in — the site has no way to know who they are, and this
 * store's account pages are hosted by Shopify, not by this theme.
 */
(function () {
  'use strict';

  var RETURN_VALUE = 'Return request';

  function init() {
    var select = document.querySelector('[data-km2-contact-reason]');
    var block = document.querySelector('[data-km2-returns-fields]');
    if (!select || !block) return;

    function sync() {
      var isReturn = select.value === RETURN_VALUE;
      block.hidden = !isReturn;
      // Fields inside a hidden block must not be focusable, or keyboard users
      // tab into inputs they cannot see.
      var fields = block.querySelectorAll('input, select, textarea');
      for (var i = 0; i < fields.length; i++) {
        if (isReturn) fields[i].removeAttribute('tabindex');
        else fields[i].setAttribute('tabindex', '-1');
      }
    }

    // ?reason=return (or ?reason=Return%20request) preselects it.
    try {
      var wanted = new URLSearchParams(window.location.search).get('reason');
      if (wanted) {
        var target = wanted.toLowerCase() === 'return' ? RETURN_VALUE : wanted;
        for (var j = 0; j < select.options.length; j++) {
          if (select.options[j].value.toLowerCase() === target.toLowerCase()) {
            select.selectedIndex = j;
            break;
          }
        }
      }
    } catch (e) {
      /* URLSearchParams unavailable — the form still works, just unpreselected. */
    }

    select.addEventListener('change', sync);
    sync();
  }

  // KM2Deps.ready: 'interactive' means parsed but DEFERRED SCRIPTS NOT YET RUN, so the old
  // `else init()` fired before the shared globals existed. Only 'complete' runs immediately.
  (window.KM2Deps ? window.KM2Deps.ready(init)
    : (document.readyState === 'complete' ? init()
       : document.addEventListener('DOMContentLoaded', init, { once: true })));
})();
